import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormWaterFixtureEntryPageContainer } from './audit-form-water-fixture-entry-page.container';
import { AuditFormWaterFixtureEntryPageMenu } from './audit-form-water-fixture-entry-page-menu';
import { useAuditFormWaterFixtureEntryPageViewModel } from './audit-form-water-fixture-entry-page.view-model';

export const AuditFormWaterFixtureEntryPage = () => {
  const logger = useLogger('pages/audit-form-water-fixture-entry');

  const viewModel = useAuditFormWaterFixtureEntryPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  const { mainMenu, isDeleteDisabled, onDelete } = viewModel;

  return (
    <FormPageLayout
      title="Water Fixture"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}
      headerChildren={
        viewModel.loadAuditFormState.state === 'success' && (
          <AuditFormWaterFixtureEntryPageMenu
            /* Menu state */
            onClose={mainMenu.close}
            onOpen={mainMenu.open}
            isOpen={mainMenu.isOpen}
            anchorEl={mainMenu.anchorEl}
            /* Menu actions */
            onDelete={onDelete.bind(null, { confirmed: false })}
            isDeleteDisabled={isDeleteDisabled}
          />
        )
      }>
      <CenteredLayout horizontal>
        <AuditFormWaterFixtureEntryPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
